import React, { useEffect, useState } from "react";
import NoSearchitems from "../../../../../components/NoSearchitems";
import { FaChevronRight } from "react-icons/fa";
import DropdownCategories from "../../Components/DropdownCategories";

const TableExpandOutflow = ({ data, outflow, expandTable }) => {
  const [openArrayNon, setOpenArrayNon] = useState(false);
  const [openArrayLarge, setOpenArrayLarge] = useState(false);
  const [openArrayLow, setOpenArrayLow] = useState(false);
  const [openArrayRecBuffer, setOpenArrayRecBuffer] = useState(false);
  const [openArrayNonRecBuffer, setOpenArrayNonRecBuffer] = useState(false);
  const ugly = {
    "Total Recurrent Expense": [
      {
        category: "Salary Recurrent inflow",
        columns: [
          {
            month: "october-2024",
            value: 0.0,
          },
          {
            month: "total",
            value: 0.0,
          },
        ],
      },
      {
        category: "Investment Recurrent inflow",
        columns: [
          {
            month: "october-2024",
            value: 0.0,
          },
          {
            month: "total",
            value: 0.0,
          },
        ],
      },
      {
        category: "Interest Recurrent inflow",
        columns: [
          {
            month: "october-2024",
            value: 283.0,
          },
          {
            month: "total",
            value: 283.0,
          },
        ],
      },
    ],
    "Total Non-Recurrent Expense": {
      "Large-value Non-Recurrent": [
        {
          category: "Fixed Deposit inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
        {
          category: "Misc-Income inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
        {
          category: "Others inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
      ],
      "Low-value Non-Recurrent": [
        {
          category: "Refund inflow",
          columns: [
            {
              month: "october-2024",
              value: 70.0,
            },
            {
              month: "total",
              value: 70.0,
            },
          ],
        },
        {
          category: "Others inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
        {
          category: "Food And Drinks inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
        {
          category: "Fixed Deposit inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
        {
          category: "Misc-Income inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
        {
          category: "Dividend inflow",
          columns: [
            {
              month: "october-2024",
              value: 0.0,
            },
            {
              month: "total",
              value: 0.0,
            },
          ],
        },
      ],
    },
  };

  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_categorization",
  });

  const [inflowTable, setInflowTable] = useState(ugly);

  const calculateTotalofColumnDouble = (item1, item2, index) => {
    let total = 0;
    for (let i = 0, len = item1.length; i < len; i++) {
      let val = item1[i].columns[index].value;
      total += val;
    }
    for (let i = 0, len = item2.length; i < len; i++) {
      let val = item2[i].columns[index].value;
      total += val;
    }
    return formatToIndianRupees(total);
  };
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  const extractTotals = (data, raw) => {
    let total = 0;
    if (!data) return "---";
    data.forEach((item) => {
      // Find the column where the month is 'total'
      const totalColumn = item.columns.find(
        (column) => column.month === "total"
      );
      total += totalColumn.value;
      // Return the value of that column
    });
    if (raw) {
      return total;
    }
    return formatToIndianRupees(total);
  };
  const [openArray, setOpenArray] = useState(false);

  const calculateTotalofColumn = (item, index) => {
    let total = 0;
    for (let i = 0, len = item.length; i < len; i++) {
      let val = item[i].columns[index].value;
      total += val;
    }
    return formatToIndianRupees(total);
  };
  const formatMonth = (text) => {
    const [month, year] = text.split("-");
    const formattedMonth =
      month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
    return `${formattedMonth} ${year}`;
  };

  useEffect(() => {
    setInflowTable(
      data
        ? data[filter.value][outflow ? "outflow_table" : "inflow_table"]
        : ugly
    );
  }, [data, filter]);
  return (
    <>
      {expandTable ? (
        <div className=" border border-[#e6ebed] rounded-lg">
          <div className="flex justify-between items-center h-[45px] px-4 pt-3">
            <p className=" text-base font-bold">
              {outflow ? "Outflow" : "Inflow"}
            </p>
            <DropdownCategories
              filterValue={filter}
              setFilterValue={setFilter}
            />
          </div>
          <div className=" flex ">
            <table className="w-[40%] box-border flex flex-col mt-4 rounded ">
              <thead className="text-xs font-semibold bg-[#f3f3f3]  ">
                <tr className="w-full flex items-center font-semibold text-sm">
                  <th className=" w-[15%] pl-4 text-center"></th>
                  <th className="text-left  pt-3 pb-3 w-[50%]">Categories</th>
                  <th className={`text-right w-[30%]`}>Amount</th>

                  {/* <th className="text-right w-[15%] pl-14">Days</th> */}
                </tr>
              </thead>

              <tbody className={`   ${[]?.length === 0 ? " " : ""}`}>
                {[1]?.length === 0 && (
                  <>
                    <NoSearchitems />
                  </>
                )}

                <>
                  <tr
                    className={`text-xs font-bold w-full flex items-center h-[43px] `}
                  >
                    <td className=" w-[15%] pl-4 text-center ">
                      <button
                        onClick={() => {
                          setOpenArray((prev) => !prev);
                        }}
                      >
                        {" "}
                        <FaChevronRight
                          color="#00394d"
                          style={{
                            transform: openArray
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </button>
                    </td>
                    <td className="text-left  w-[50%] font-medium">
                      {`Total Recurrent ${
                        outflow ? "Outflow" : "Inflow"
                      } amount` || "--"}
                    </td>
                    <td className={`text-right w-[30%] pt-3 pb-2 font-bold`}>
                      {extractTotals(inflowTable["Total Recurrent Expense"]) ||
                        "--"}
                    </td>
                    {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                  </tr>
                  {openArray && (
                    <>
                      {inflowTable["Total Recurrent Expense"]?.map(
                        (item, index) => (
                          <tr
                            className={`text-xs font-medium w-full flex items-center h-[43px]  `}
                          >
                            <td className=" w-[15%] pl-4 text-center "></td>
                            <td className="text-left pl-4  w-[50%]">
                              {item?.category || "--"}
                            </td>
                            <td
                              className={`text-right w-[30%] pt-3 pb-2 font-medium`}
                            >
                              {formatToIndianRupees(
                                item?.columns[item?.columns.length - 1]?.value
                              ) || "--"}
                            </td>
                            {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                          </tr>
                        )
                      )}
                    </>
                  )}
                  {/* ///// */}
                  <tr
                    className={`text-xs font-bold w-full flex items-center h-[43px] `}
                  >
                    <td className=" w-[15%] pl-4 text-center ">
                      <button
                        onClick={() => {
                          setOpenArrayNon((prev) => !prev);
                          setOpenArrayLarge(false);
                          setOpenArrayLow(false);
                        }}
                      >
                        {" "}
                        <FaChevronRight
                          color="#00394d"
                          style={{
                            transform: openArrayNon
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </button>
                    </td>
                    <td className="text-left  w-[50%] font-medium">
                      {`Total Non-Recurrent ${
                        outflow ? "Outflow" : "Inflow"
                      } ` || "--"}
                    </td>
                    <td className={`text-right w-[30%] pt-3 pb-2 font-bold`}>
                      {formatToIndianRupees(
                        extractTotals(
                          inflowTable["Total Non-Recurrent Expense"][
                            "Large-value Non-Recurrent"
                          ],
                          true
                        ) +
                          extractTotals(
                            inflowTable["Total Non-Recurrent Expense"][
                              "Low-value Non-Recurrent"
                            ],
                            true
                          )
                      ) || "--"}
                    </td>
                    {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                  </tr>
                  {openArrayNon && (
                    <>
                      <tr
                        className={`text-xs font-bold w-full flex items-center h-[43px] pl-4 `}
                      >
                        <td className=" w-[15%] pl-4 text-center ">
                          <button
                            onClick={() => {
                              setOpenArrayLarge((prev) => !prev);
                            }}
                          >
                            {" "}
                            <FaChevronRight
                              color="#00394d"
                              style={{
                                transform: openArrayLarge
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                                transition: "all 0.3s ease",
                              }}
                            />
                          </button>
                        </td>
                        <td className="text-left  w-[50%] font-medium">
                          {"Large-value Non-Recurrent" || "--"}
                        </td>
                        <td
                          className={`text-right w-[30%] pt-3 pb-2 font-bold`}
                        >
                          {extractTotals(
                            inflowTable["Total Non-Recurrent Expense"][
                              "Large-value Non-Recurrent"
                            ]
                          ) || "--"}
                        </td>
                        {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                      </tr>
                      {openArrayLarge && (
                        <>
                          {inflowTable["Total Non-Recurrent Expense"][
                            "Large-value Non-Recurrent"
                          ]?.map((item, index) => (
                            <tr
                              className={`text-xs font-medium w-full flex items-center h-[43px] pl-3 `}
                            >
                              <td className=" w-[15%] pl-4 text-center "></td>
                              <td className="text-left pl-4  w-[50%]">
                                {item?.category || "--"}
                              </td>
                              <td
                                className={`text-right w-[30%] pt-3 pb-2 font-medium`}
                              >
                                {formatToIndianRupees(
                                  item?.columns[item?.columns.length - 1]?.value
                                ) || "--"}
                              </td>
                              {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                            </tr>
                          ))}
                        </>
                      )}
                      <tr
                        className={`text-xs font-bold w-full flex items-center h-[43px] pl-4 `}
                      >
                        <td className=" w-[15%] pl-4 text-center ">
                          <button
                            onClick={() => {
                              setOpenArrayLow((prev) => !prev);
                            }}
                          >
                            {" "}
                            <FaChevronRight
                              color="#00394d"
                              style={{
                                transform: openArrayLow
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                                transition: "all 0.3s ease",
                              }}
                            />
                          </button>
                        </td>
                        <td className="text-left  w-[50%] font-medium">
                          {"Low-value Non-Recurrent" || "--"}
                        </td>
                        <td
                          className={`text-right w-[30%] pt-3 pb-2 font-bold`}
                        >
                          {extractTotals(
                            inflowTable["Total Non-Recurrent Expense"][
                              "Low-value Non-Recurrent"
                            ]
                          ) || "--"}
                        </td>
                        {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                      </tr>
                    </>
                  )}

                  {openArrayLow && (
                    <>
                      {inflowTable["Total Non-Recurrent Expense"][
                        "Low-value Non-Recurrent"
                      ]?.map((item, index) => (
                        <tr
                          className={`text-xs font-medium w-full flex items-center h-[43px] pl-3  `}
                        >
                          <td className=" w-[15%] pl-4 text-center "></td>
                          <td className="text-left pl-4  w-[50%]">
                            {item?.category || "--"}
                          </td>
                          <td
                            className={`text-right w-[30%] pt-3 pb-2 font-medium`}
                          >
                            {formatToIndianRupees(
                              item?.columns[item?.columns.length - 1]?.value
                            ) || "--"}
                          </td>
                          {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                        </tr>
                      ))}
                    </>
                  )}
                  {outflow && (
                    <>
                      <tr
                        className={`text-xs font-bold w-full flex items-center h-[43px] `}
                      >
                        <td className=" w-[15%] pl-4 text-center ">
                          <button
                            onClick={() => {
                              setOpenArrayRecBuffer((prev) => !prev);
                            }}
                          >
                            {" "}
                            <FaChevronRight
                              color="#00394d"
                              style={{
                                transform: openArrayRecBuffer
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                                transition: "all 0.3s ease",
                              }}
                            />
                          </button>
                        </td>
                        <td className="text-left  w-[50%] font-medium">
                          {"Total Recurrent Financial Buffer" || "--"}
                        </td>
                        <td
                          className={`text-right w-[30%] pt-3 pb-2 font-bold`}
                        >
                          {extractTotals(
                            inflowTable["Total Recurrent Financial Buffer"]
                          ) || "--"}
                        </td>
                        {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                      </tr>
                      {openArrayRecBuffer && (
                        <>
                          {inflowTable["Total Recurrent Financial Buffer"]?.map(
                            (item, index) => (
                              <tr
                                className={`text-xs font-medium w-full flex items-center h-[43px]  `}
                              >
                                <td className=" w-[15%] pl-4 text-center "></td>
                                <td className="text-left pl-4  w-[50%]">
                                  {item?.category || "--"}
                                </td>
                                <td
                                  className={`text-right w-[30%] pt-3 pb-2 font-medium`}
                                >
                                  {formatToIndianRupees(
                                    item?.columns[item?.columns.length - 1]
                                      ?.value
                                  ) || "--"}
                                </td>
                                {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                              </tr>
                            )
                          )}
                        </>
                      )}
                      {/* ///// non rec buffer */}
                      <tr
                        className={`text-xs font-bold w-full flex items-center h-[43px] `}
                      >
                        <td className=" w-[15%] pl-4 text-center ">
                          <button
                            onClick={() => {
                              setOpenArrayNonRecBuffer((prev) => !prev);
                            }}
                          >
                            {" "}
                            <FaChevronRight
                              color="#00394d"
                              style={{
                                transform: openArrayNonRecBuffer
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                                transition: "all 0.3s ease",
                              }}
                            />
                          </button>
                        </td>
                        <td className="text-left  w-[50%] font-medium">
                          {"Total Non-Recurrent Financial Buffer" || "--"}
                        </td>
                        <td
                          className={`text-right w-[30%] pt-3 pb-2 font-bold`}
                        >
                          {extractTotals(
                            inflowTable["Total Non-Recurrent Financial Buffer"]
                          ) || "--"}
                        </td>
                        {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                      </tr>
                      {openArrayNonRecBuffer && (
                        <>
                          {inflowTable[
                            "Total Non-Recurrent Financial Buffer"
                          ]?.map((item, index) => (
                            <tr
                              className={`text-xs font-medium w-full flex items-center h-[43px]  `}
                            >
                              <td className=" w-[15%] pl-4 text-center "></td>
                              <td className="text-left pl-4  w-[50%]">
                                {item?.category || "--"}
                              </td>
                              <td
                                className={`text-right w-[30%] pt-3 pb-2 font-medium`}
                              >
                                {formatToIndianRupees(
                                  item?.columns[item?.columns.length - 1]?.value
                                ) || "--"}
                              </td>
                              {/* <td className="text-right w-[15%] pl-10">
                  {" "}
                 {data.days}
                </td> */}
                            </tr>
                          ))}
                        </>
                      )}
                    </>
                  )}
                </>
              </tbody>
            </table>
            <div className=" w-[60%] overflow-x-auto ">
              <table className="min-w-fit box-border flex flex-col mt-4 rounded ">
                <thead className="text-xs font-semibold bg-[#f3f3f3]  ">
                  <tr className="w-full flex items-center font-semibold text-sm">
                    {inflowTable["Total Recurrent Expense"][0].columns?.map(
                      (month, index) => {
                        if (month.month === "total") return <></>;
                        return (
                          <th
                            key={index}
                            className={`text-right w-[147px] pr-4 pt-3 pb-3`}
                          >
                            {formatMonth(month.month) || "--"}
                          </th>
                        );
                      }
                    )}

                    {/* <th className="text-right w-[15%] pl-14">Days</th> */}
                  </tr>
                </thead>

                <tbody className={`   ${[]?.length === 0 ? " " : ""}`}>
                  {[1]?.length === 0 && (
                    <>
                      <NoSearchitems />
                    </>
                  )}

                  <>
                    <tr
                      className={`text-xs  w-full flex items-center h-[43px]  `}
                    >
                      {inflowTable["Total Recurrent Expense"][0].columns?.map(
                        (item, index) => {
                          if (item.month === "total") return <></>;
                          return (
                            <td
                              className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                            >
                              {calculateTotalofColumn(
                                inflowTable["Total Recurrent Expense"],
                                index
                              ) || "--"}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    {openArray && (
                      <>
                        {inflowTable["Total Recurrent Expense"]?.map(
                          (item, index) => (
                            <tr
                              className={`text-xs font-medium w-full flex items-center h-[43px]`}
                            >
                              {inflowTable["Total Recurrent Expense"][
                                index
                              ].columns?.map((month, index1) => {
                                if (month.month === "total") return <></>;
                                return (
                                  <td
                                    className={`text-right w-[147px] pr-4 pt-3 pb-2`}
                                  >
                                    {formatToIndianRupees(month.value) || "--"}
                                  </td>
                                );
                              })}
                            </tr>
                          )
                        )}
                      </>
                    )}
                    <tr
                      className={`text-xs  w-full flex items-center h-[43px]  $`}
                    >
                      {inflowTable["Total Recurrent Expense"][0].columns?.map(
                        (item, index) => {
                          if (item.month === "total") return <></>;
                          return (
                            <td
                              className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                            >
                              {calculateTotalofColumnDouble(
                                inflowTable["Total Non-Recurrent Expense"][
                                  "Large-value Non-Recurrent"
                                ],
                                inflowTable["Total Non-Recurrent Expense"][
                                  "Low-value Non-Recurrent"
                                ],
                                index
                              ) || "--"}
                            </td>
                          );
                        }
                      )}
                    </tr>
                    {openArrayNon && (
                      <>
                        <tr
                          className={`text-xs  w-full flex items-center h-[43px]  `}
                        >
                          {inflowTable["Total Non-Recurrent Expense"][
                            "Large-value Non-Recurrent"
                          ][0].columns?.map((item, index) => {
                            if (item.month === "total") return <></>;
                            return (
                              <td
                                className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                              >
                                {calculateTotalofColumn(
                                  inflowTable["Total Non-Recurrent Expense"][
                                    "Large-value Non-Recurrent"
                                  ],
                                  index
                                ) || "--"}
                              </td>
                            );
                          })}
                        </tr>
                        {openArrayLarge && (
                          <>
                            {inflowTable["Total Non-Recurrent Expense"][
                              "Large-value Non-Recurrent"
                            ]?.map((item, index) => (
                              <tr
                                className={`text-xs font-medium w-full flex items-center h-[43px]`}
                              >
                                {inflowTable["Total Non-Recurrent Expense"][
                                  "Large-value Non-Recurrent"
                                ][index].columns?.map((month, index1) => {
                                  if (month.month === "total") return <></>;
                                  return (
                                    <td
                                      className={`text-right w-[147px] pr-4 pt-3 pb-2`}
                                    >
                                      {formatToIndianRupees(month.value) ||
                                        "--"}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </>
                        )}
                        <tr
                          className={`text-xs  w-full flex items-center h-[43px] `}
                        >
                          {inflowTable["Total Non-Recurrent Expense"][
                            "Low-value Non-Recurrent"
                          ][0].columns?.map((item, index) => {
                            if (item.month === "total") return <></>;
                            return (
                              <td
                                className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                              >
                                {calculateTotalofColumn(
                                  inflowTable["Total Non-Recurrent Expense"][
                                    "Low-value Non-Recurrent"
                                  ],
                                  index
                                ) || "--"}
                              </td>
                            );
                          })}
                        </tr>
                      </>
                    )}

                    {openArrayLow && (
                      <>
                        {inflowTable["Total Non-Recurrent Expense"][
                          "Low-value Non-Recurrent"
                        ]?.map((item, index) => (
                          <tr
                            className={`text-xs font-medium w-full flex items-center h-[43px]`}
                          >
                            {inflowTable["Total Non-Recurrent Expense"][
                              "Low-value Non-Recurrent"
                            ][index].columns?.map((month, index1) => {
                              if (month.month === "total") return <></>;
                              return (
                                <td
                                  className={`text-right w-[147px] pr-4 pt-3 pb-2`}
                                >
                                  {formatToIndianRupees(month.value) || "--"}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </>
                    )}
                    {outflow && (
                      <>
                        <tr
                          className={`text-xs  w-full flex items-center h-[43px]  `}
                        >
                          {inflowTable[
                            "Total Recurrent Financial Buffer"
                          ][0].columns?.map((item, index) => {
                            if (item.month === "total") return <></>;
                            return (
                              <td
                                className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                              >
                                {calculateTotalofColumn(
                                  inflowTable[
                                    "Total Recurrent Financial Buffer"
                                  ],
                                  index
                                ) || "--"}
                              </td>
                            );
                          })}
                        </tr>
                        {openArrayRecBuffer && (
                          <>
                            {inflowTable[
                              "Total Recurrent Financial Buffer"
                            ]?.map((item, index) => (
                              <tr
                                className={`text-xs font-medium w-full flex items-center h-[43px]`}
                              >
                                {inflowTable[
                                  "Total Recurrent Financial Buffer"
                                ][index].columns?.map((month, index1) => {
                                  if (month.month === "total") return <></>;
                                  return (
                                    <td
                                      className={`text-right w-[147px] pr-4 pt-3 pb-2`}
                                    >
                                      {formatToIndianRupees(month.value) ||
                                        "--"}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </>
                        )}
                        <tr
                          className={`text-xs  w-full flex items-center h-[43px]  `}
                        >
                          {inflowTable[
                            "Total Non-Recurrent Financial Buffer"
                          ][0].columns?.map((item, index) => {
                            if (item.month === "total") return <></>;
                            return (
                              <td
                                className={`text-right w-[147px] pr-4 pt-3 pb-2 font-bold`}
                              >
                                {calculateTotalofColumn(
                                  inflowTable[
                                    "Total Non-Recurrent Financial Buffer"
                                  ],
                                  index
                                ) || "--"}
                              </td>
                            );
                          })}
                        </tr>
                        {openArrayNonRecBuffer && (
                          <>
                            {inflowTable[
                              "Total Non-Recurrent Financial Buffer"
                            ]?.map((item, index) => (
                              <tr
                                className={`text-xs font-medium w-full flex items-center h-[43px]`}
                              >
                                {inflowTable[
                                  "Total Non-Recurrent Financial Buffer"
                                ][index].columns?.map((month, index1) => {
                                  if (month.month === "total") return <></>;
                                  return (
                                    <td
                                      className={`text-right w-[147px] pr-4 pt-3 pb-2`}
                                    >
                                      {formatToIndianRupees(month.value) ||
                                        "--"}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </>
                        )}
                      </>
                    )}
                  </>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default TableExpandOutflow;
